/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddressToken,
  FormattedAddressesResponse,
  MigrationResponse,
  NewShippingAddress,
  PreviewFormatResponse,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  ShippingAddress,
} from '../models/index';
import {
    AddressTokenFromJSON,
    AddressTokenToJSON,
    FormattedAddressesResponseFromJSON,
    FormattedAddressesResponseToJSON,
    MigrationResponseFromJSON,
    MigrationResponseToJSON,
    NewShippingAddressFromJSON,
    NewShippingAddressToJSON,
    PreviewFormatResponseFromJSON,
    PreviewFormatResponseToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    ShippingAddressFromJSON,
    ShippingAddressToJSON,
} from '../models/index';

export interface ShippingAddressCountRequest {
    where?: string;
}

export interface ShippingAddressCreateRequest {
    data?: NewShippingAddress;
}

export interface ShippingAddressCreateChangeStreamGetShippingAddressesChangeStreamRequest {
    options?: string;
}

export interface ShippingAddressCreateChangeStreamPostShippingAddressesChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface ShippingAddressCreateDefaultsRequest {
    courierId: string;
}

export interface ShippingAddressDeleteByIdRequest {
    id: string;
}

export interface ShippingAddressExistsGetShippingAddressesidExistsRequest {
    id: string;
}

export interface ShippingAddressExistsHeadShippingAddressesidRequest {
    id: string;
}

export interface ShippingAddressFindRequest {
    filter?: string;
}

export interface ShippingAddressFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ShippingAddressFindOneRequest {
    filter?: string;
}

export interface ShippingAddressGetFormattedAddressesRequest {
    courierId: string;
    userId?: string;
}

export interface ShippingAddressMigrateFromCourierSettingsRequest {
    courierId: string;
}

export interface ShippingAddressPatchOrCreateRequest {
    data?: ShippingAddress;
}

export interface ShippingAddressPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface ShippingAddressPrototypePatchAttributesRequest {
    id: string;
    data?: ShippingAddress;
}

export interface ShippingAddressPrototypePreviewFormatRequest {
    id: string;
}

export interface ShippingAddressReplaceByIdRequest {
    id: string;
    data?: ShippingAddress;
}

export interface ShippingAddressReplaceOrCreateRequest {
    data?: ShippingAddress;
}

export interface ShippingAddressUpdateAllRequest {
    where?: string;
    data?: ShippingAddress;
}

export interface ShippingAddressUpdateByIdRequest {
    id: string;
    data?: ShippingAddress;
}

export interface ShippingAddressUpsertWithWhereRequest {
    where?: string;
    data?: ShippingAddress;
}

/**
 * 
 */
export class ShippingAddressApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async shippingAddressCountRaw(requestParameters: ShippingAddressCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters.where !== undefined) {
            queryParameters['where'] = requestParameters.where;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async shippingAddressCount(requestParameters: ShippingAddressCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.shippingAddressCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shippingAddressCreateRaw(requestParameters: ShippingAddressCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shippingAddressCreate(requestParameters: ShippingAddressCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async shippingAddressCreateChangeStreamGetShippingAddressesChangeStreamRaw(requestParameters: ShippingAddressCreateChangeStreamGetShippingAddressesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters.options !== undefined) {
            queryParameters['options'] = requestParameters.options;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async shippingAddressCreateChangeStreamGetShippingAddressesChangeStream(requestParameters: ShippingAddressCreateChangeStreamGetShippingAddressesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shippingAddressCreateChangeStreamGetShippingAddressesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async shippingAddressCreateChangeStreamPostShippingAddressesChangeStreamRaw(requestParameters: ShippingAddressCreateChangeStreamPostShippingAddressesChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters.roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async shippingAddressCreateChangeStreamPostShippingAddressesChangeStream(requestParameters: ShippingAddressCreateChangeStreamPostShippingAddressesChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shippingAddressCreateChangeStreamPostShippingAddressesChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create default shipping addresses for a courier
     */
    async shippingAddressCreateDefaultsRaw(requestParameters: ShippingAddressCreateDefaultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShippingAddress>>> {
        if (requestParameters.courierId === null || requestParameters.courierId === undefined) {
            throw new runtime.RequiredError('courierId','Required parameter requestParameters.courierId was null or undefined when calling shippingAddressCreateDefaults.');
        }

        const queryParameters: any = {};

        if (requestParameters.courierId !== undefined) {
            queryParameters['courierId'] = requestParameters.courierId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/create-defaults`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShippingAddressFromJSON));
    }

    /**
     * Create default shipping addresses for a courier
     */
    async shippingAddressCreateDefaults(requestParameters: ShippingAddressCreateDefaultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShippingAddress>> {
        const response = await this.shippingAddressCreateDefaultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shippingAddressDeleteByIdRaw(requestParameters: ShippingAddressDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressDeleteById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shippingAddressDeleteById(requestParameters: ShippingAddressDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shippingAddressDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async shippingAddressExistsGetShippingAddressesidExistsRaw(requestParameters: ShippingAddressExistsGetShippingAddressesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressExistsGetShippingAddressesidExists.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async shippingAddressExistsGetShippingAddressesidExists(requestParameters: ShippingAddressExistsGetShippingAddressesidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.shippingAddressExistsGetShippingAddressesidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async shippingAddressExistsHeadShippingAddressesidRaw(requestParameters: ShippingAddressExistsHeadShippingAddressesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressExistsHeadShippingAddressesid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async shippingAddressExistsHeadShippingAddressesid(requestParameters: ShippingAddressExistsHeadShippingAddressesidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.shippingAddressExistsHeadShippingAddressesidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shippingAddressFindRaw(requestParameters: ShippingAddressFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShippingAddress>>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShippingAddressFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shippingAddressFind(requestParameters: ShippingAddressFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShippingAddress>> {
        const response = await this.shippingAddressFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shippingAddressFindByIdRaw(requestParameters: ShippingAddressFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressFindById.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shippingAddressFindById(requestParameters: ShippingAddressFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async shippingAddressFindOneRaw(requestParameters: ShippingAddressFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async shippingAddressFindOne(requestParameters: ShippingAddressFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available tokens for address formatting
     */
    async shippingAddressGetAvailableTokensRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AddressToken>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/available-tokens`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AddressTokenFromJSON));
    }

    /**
     * Get available tokens for address formatting
     */
    async shippingAddressGetAvailableTokens(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AddressToken>> {
        const response = await this.shippingAddressGetAvailableTokensRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all addresses for a courier with formatted examples
     */
    async shippingAddressGetFormattedAddressesRaw(requestParameters: ShippingAddressGetFormattedAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormattedAddressesResponse>> {
        if (requestParameters.courierId === null || requestParameters.courierId === undefined) {
            throw new runtime.RequiredError('courierId','Required parameter requestParameters.courierId was null or undefined when calling shippingAddressGetFormattedAddresses.');
        }

        const queryParameters: any = {};

        if (requestParameters.courierId !== undefined) {
            queryParameters['courierId'] = requestParameters.courierId;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/formatted-addresses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormattedAddressesResponseFromJSON(jsonValue));
    }

    /**
     * Get all addresses for a courier with formatted examples
     */
    async shippingAddressGetFormattedAddresses(requestParameters: ShippingAddressGetFormattedAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormattedAddressesResponse> {
        const response = await this.shippingAddressGetFormattedAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migrate existing courier settings addresses to ShippingAddress records
     */
    async shippingAddressMigrateFromCourierSettingsRaw(requestParameters: ShippingAddressMigrateFromCourierSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MigrationResponse>> {
        if (requestParameters.courierId === null || requestParameters.courierId === undefined) {
            throw new runtime.RequiredError('courierId','Required parameter requestParameters.courierId was null or undefined when calling shippingAddressMigrateFromCourierSettings.');
        }

        const queryParameters: any = {};

        if (requestParameters.courierId !== undefined) {
            queryParameters['courierId'] = requestParameters.courierId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/migrate-from-courier-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MigrationResponseFromJSON(jsonValue));
    }

    /**
     * Migrate existing courier settings addresses to ShippingAddress records
     */
    async shippingAddressMigrateFromCourierSettings(requestParameters: ShippingAddressMigrateFromCourierSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MigrationResponse> {
        const response = await this.shippingAddressMigrateFromCourierSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async shippingAddressPatchOrCreateRaw(requestParameters: ShippingAddressPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async shippingAddressPatchOrCreate(requestParameters: ShippingAddressPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async shippingAddressPrototypeGetCourierRaw(requestParameters: ShippingAddressPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressPrototypeGetCourier.');
        }

        const queryParameters: any = {};

        if (requestParameters.refresh !== undefined) {
            queryParameters['refresh'] = requestParameters.refresh;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async shippingAddressPrototypeGetCourier(requestParameters: ShippingAddressPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shippingAddressPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shippingAddressPrototypePatchAttributesRaw(requestParameters: ShippingAddressPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressPrototypePatchAttributes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shippingAddressPrototypePatchAttributes(requestParameters: ShippingAddressPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview address formatting with sample data
     */
    async shippingAddressPrototypePreviewFormatRaw(requestParameters: ShippingAddressPrototypePreviewFormatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreviewFormatResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressPrototypePreviewFormat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShippingAddresses/{id}/preview`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreviewFormatResponseFromJSON(jsonValue));
    }

    /**
     * Preview address formatting with sample data
     */
    async shippingAddressPrototypePreviewFormat(requestParameters: ShippingAddressPrototypePreviewFormatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreviewFormatResponse> {
        const response = await this.shippingAddressPrototypePreviewFormatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async shippingAddressReplaceByIdRaw(requestParameters: ShippingAddressReplaceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressReplaceById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async shippingAddressReplaceById(requestParameters: ShippingAddressReplaceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressReplaceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async shippingAddressReplaceOrCreateRaw(requestParameters: ShippingAddressReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async shippingAddressReplaceOrCreate(requestParameters: ShippingAddressReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async shippingAddressUpdateAllRaw(requestParameters: ShippingAddressUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters.where !== undefined) {
            queryParameters['where'] = requestParameters.where;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async shippingAddressUpdateAll(requestParameters: ShippingAddressUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.shippingAddressUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update attributes of a model instance and persist it into the data source.
     */
    async shippingAddressUpdateByIdRaw(requestParameters: ShippingAddressUpdateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shippingAddressUpdateById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Update attributes of a model instance and persist it into the data source.
     */
    async shippingAddressUpdateById(requestParameters: ShippingAddressUpdateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressUpdateByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async shippingAddressUpsertWithWhereRaw(requestParameters: ShippingAddressUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShippingAddress>> {
        const queryParameters: any = {};

        if (requestParameters.where !== undefined) {
            queryParameters['where'] = requestParameters.where;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/ShippingAddresses/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShippingAddressToJSON(requestParameters.data),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShippingAddressFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async shippingAddressUpsertWithWhere(requestParameters: ShippingAddressUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShippingAddress> {
        const response = await this.shippingAddressUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
